import { observable, action } from 'mobx'
import 'rxjs/add/operator/mapTo'

export const handleDragStart = dragStart$ => {
    dragStart$.mapTo(true).subscribe(panorama.setDragging)
}

export const handleDragEnd = dragEnd$ => {
    dragEnd$.mapTo(false).subscribe(panorama.setDragging)
}

export const handleAutoRotate = isRotating => panorama.setIsAutoRotating(isRotating)

const panorama = observable(
    {
        isUserDraggingPano: false,
        isPanoAutoRotating: false,
        setDragging(isDragging) {
            this.isUserDraggingPano = isDragging
        },
        setIsAutoRotating(isRotating) {
            this.isPanoAutoRotating = isRotating
        },
    },
    {
        setDragging: action.bound,
        setIsAutoRotating: action.bound,
    }
)

export default panorama
